import Vue from 'vue';

import Component from '@/scripts/core/Component';
import ProductGalleryComponent from '@/scripts/vue/components/ProductGallery.vue';

class ProductGallery extends Component {
  onInit() {
    const el = document.createElement('div');
    this.$el.appendChild(el);

    const { items, href, sizes } = this.$props;

    this.productGallery = new Vue({
      el,
      render(h) {
        return h(ProductGalleryComponent, {
          props: {
            items,
            href,
            sizes,
          },
        });
      },
    });
  }

  onDestroy() {
    if (!this.productGallery) return;
    this.productGallery.$destroy();
    this.productGallery.$el.parentElement.removeChild(this.productGallery.$el);
    this.productGallery = null;
  }
}

export default ProductGallery;
